<template lang="html">
  <div class="body">
    <h3 style="text-align:center;">登录管理后台</h3>
    <el-form
      label-position="left"
      label-width="50px"
    >
      <el-alert
        v-if="loginFailed"
        title="登录失败，请重试"
        type="error"
        :closable="false"
        :center="true"
        :show-icon="false"
        style="margin-bottom: 20px;"
      >
      </el-alert>
      <el-form-item label="手机">
        <el-input v-model="mobile"></el-input>
      </el-form-item>
      <el-form-item label="密码">
        <el-input v-model="password" type="password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="onSubmit"
        >
          登录
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import VueLocalStorage from 'vue-localstorage'
  import Vue from 'vue'
  import store from '../../store/index';
  Vue.use(VueLocalStorage)
  export default {
    data() {
      return {
        labelPosition: 'left',
        mobile: '+86',
        password: '',
        loginFailed: false
      }
    },
    mounted () {
      let mobile_num = Vue.localStorage.get('mobile_num', null)
      // let password = Vue.localStorage.get('password', null)
      if (mobile_num) {
        this.mobile = mobile_num
      }
      // if (mobile_num && password) {
      //   this.mobile = mobile_num
      //   this.password = password
      //   this.onSubmit()
      // }
    },
    methods: {
      onSubmit () {
        let that = this
        window.console.log("login")
        let params = {
          mobile_num: that.mobile,
          password: that.password
        }
        that.$api.account.login(params).then(res => {
          window.console.log("登录成功")
          window.console.log(res)
          let refreshTime = new Date().getTime() + 50 * 60 * 1000
          Vue.localStorage.set('token', res.data.token)
          Vue.localStorage.set('mobile_num', that.mobile)
          // Vue.localStorage.set('password', that.password)
          Vue.localStorage.set('refreshTime', refreshTime)
          store.commit('setToken', res.data.token)
          store.commit('setRefreshTime', refreshTime)
          that.$router.replace({
            name: 'Home'
          })
        }).catch(error => {
          window.console.log("登录失败")
          window.console.log(error)
          that.loginFailed = true
          that.password = ''
        })
      }
    }
  }
</script>

<style lang="css" scoped>
  .body {
    padding: 15px 30px 15px 30px;
  }
</style>
